'use strict';

var _ = require('lodash');
var PaxGridController = function PaxGridController($scope, $q, dataProvider, paxGridService, PaxGridSelectionModel, BrushSelectionFilter, $timeout, $rootScope) {
  if ($scope.gridId === 'spill-pax-gap' || $scope.gridId === 'recap-pax-gap') {
    $scope.config = _.clone(require('../config/pax-grid-config.json'));
    $scope.config.columns = $scope.config.columns.concat(dataProvider.generateRelevantDaysOfWeek());
  } else if ($scope.gridId === 'spill-dtd-dow-pax-gap' || $scope.gridId === 'recap-dtd-dow-pax-gap') {
    $scope.config = _.clone(require('../config/pax-grid-dtd-dow-config.json'));
    $scope.config.columns = $scope.config.columns.concat(dataProvider.generateRelevantDaysOfWeek());
  } else if ($scope.gridId === 'spill-service-dtd-pax-gap' || $scope.gridId === 'recap-service-dtd-pax-gap') {
    $scope.config = _.clone(require('../config/pax-grid-service-dtd-config.json'));
    $scope.config.columns = $scope.config.columns.concat(dataProvider.generateRTPRanges());
  } else if ($scope.gridId === 'service-opportunities') {
    $scope.config = require('../config/service-opportunities-grid-config.json');
  } else if ($scope.gridId === 'loco-fare-heatmap') {
    $scope.config = _.clone(require('../config/loco-fare-heatmap.json'));
    $scope.config.columns = $scope.config.columns.concat(dataProvider.generateRTPRanges());
  }
  var model = new PaxGridSelectionModel();
  model.setColumns($scope.config.columns);
  function getFilterFieldName(selectionType) {
    var filterFields = $scope.filterFields.split('-');
    if (selectionType === 'row') {
      return filterFields[0];
    } else {
      return filterFields[1];
    }
  }
  function emitEvent() {
    var filter;
    var filterArg = {};
    if (model.selectionValues.length !== 0) {
      filterArg[getFilterFieldName(model.selectionType)] = model.selectionValues;
      filter = new BrushSelectionFilter($scope.brushFilterType, [filterArg]);
    } else {
      filter = new BrushSelectionFilter($scope.brushFilterType, []);
    }
    filter.source = $scope.gridId;
    filter.selectionType = model.selectionType;
    $rootScope.$broadcast('pax-grid:filterApplied', filter);
    $timeout(function () {
      if ($scope.brushFilterChanged) {
        $scope.brushFilterChanged(filter);
      }
    });
  }
  var renderGrid = function renderGrid(data) {
    var filters = dataProvider.getFilters($scope.gridId);
    if (_.isUndefined(filters) || _.isUndefined(filters['filter-component'])) {
      return;
    }
    var colorConfig;
    if ($scope.dynamicColors) {
      colorConfig = dataProvider.getDynamicColorMap($scope.gridColorId, data);
    } else {
      colorConfig = dataProvider.getColorConfiguration($scope.gridColorId);
    }
    var newRows = paxGridService.formatData($scope.config.columns, data, colorConfig, $scope.config.sortCriteria, $scope.rowSpanField);
    if (isRenderingNeeded(newRows, $scope.rows)) {
      $scope.rows = newRows;
      model.setRows($scope.rows);
      $scope.render();
    }
  };
  function isRenderingNeeded(newRows, oldRows) {
    return !_.isEqual(newRows, oldRows);
  }
  $scope.selectionByColumn = function (columnNumber, ctrlKey, shiftKey) {
    model.selectionByColumn();
    model.setSelection(columnNumber, ctrlKey, shiftKey);
    $scope.highlightCells($scope.rows, model.isRowSelection(), $scope.config.columns, model.selectionValues);
    emitEvent();
  };
  $scope.selectionByRow = function (rowNumber, ctrlKey, shiftKey) {
    model.selectionByRow();
    model.setSelection(rowNumber, ctrlKey, shiftKey);
    $scope.highlightCells($scope.rows, model.isRowSelection(), $scope.config.columns, model.selectionValues);
    emitEvent();
  };
  $scope.resetHandler = function () {
    $scope.resetSelection();
    model.resetSelection();
    emitEvent();
  };
  $scope.loadData = function () {
    $scope.resetHandler();
    dataProvider.getData($scope.gridId).then(renderGrid);
  };
  $scope.$on('pax-grid:filterApplied', function (event, filter) {
    if (filter.filterType === $scope.brushFilterType && filter.source !== $scope.gridId) {
      model.selectionType = filter.selectionType;
      if (filter && !filter.isEmpty()) {
        var filterFieldName = getFilterFieldName(filter.selectionType);
        model.setSelectionValues(filter.filterArguments[0][0][filterFieldName]);
        $scope.highlightCells($scope.rows, model.isRowSelection(), $scope.config.columns, model.selectionValues);
      } else {
        $scope.resetSelection();
        model.resetSelection();
      }
    }
  });
  $scope.$on('brush-filter:filterApplied', function (event, filter) {
    if (filter.filterType !== $scope.brushFilterType) {
      $scope.loadData();
    }
  });
  $scope.$on('rom-analysis-panel:displayChanged', function () {
    $scope.loadData();
  });
};
PaxGridController.$inject = ['$scope', '$q', 'PaxGridDataProviderService', 'PaxGridService', 'PaxGridSelectionModelFactory', 'BrushSelectionFilterFactory', '$timeout', '$rootScope'];
module.exports = PaxGridController;